/* Notes:  this component  works well for bulk edit so far,
     might need some works here then re-use it  when we migrate event detail page
*/

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    NgZone,
    OnInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    Renderer2,
    ViewChild,
} from "@angular/core";
import { S25EditableAbstract } from "../s25.editable.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ModalImageI } from "../../modal/modals/modal.image.upload.component";
import { CustomAttributeService } from "../../../services/custom.attribute.service";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { Bind } from "../../../decorators/bind.decorator";
import { CustomAttributes } from "../../../pojo/CustomAttributes";
import { S25File, FileUploadComponent } from "../../s25-file-upload/s25.file.upload.component";
import { AttachmentService } from "../../../services/attachment.service";
import { Item } from "../../../pojo/Item";
import { MasterDefinitionUtil } from "../../../util/master.definition.util";
import { S25Util } from "../../../util/s25-util";
import ItemValue = CustomAttributes.ItemValue;
import { Proto } from "../../../pojo/Proto";
import NumericalBoolean = Proto.NumericalBoolean;
import { FileStoreUtil } from "../../../util/filestore.util";

@TypeManagerDecorator("s25-ng-editable-custom-attribute")
@Component({
    selector: "s25-ng-editable-custom-attribute",
    template: `
        <div *ngIf="init">
            <div [ngSwitch]="attributeType" class="attributeRow">
                <label for="customAttributeValue" class="ngBlock"
                    ><s25-ng-link-parser [text]="attributeName"></s25-ng-link-parser>:
                </label>

                <div *ngSwitchCase="AttributeType.Boolean">
                    <s25-toggle-button
                        [modelValue]="value"
                        (modelValueChange)="onValueChangeCommit($event)"
                        name="attribute value"
                        [disabled]="readOnly"
                    ></s25-toggle-button>
                </div>

                <div *ngSwitchCase="AttributeType.Text">
                    <s25-ng-editable-text
                        *ngIf="!discreteOptions[attributeId]"
                        (valChange)="onValueChange($event)"
                        [val]="value"
                        [hasCommit]="hasCommit"
                        [onCommit]="onCommit"
                        [readOnly]="readOnly"
                        name="attribute value"
                    ></s25-ng-editable-text>

                    @if (discreteOptions[attributeId] && multiVal === 0) {
                        @if (!readOnly) {
                            <select
                                [ngModel]="value"
                                (ngModelChange)="onValueChangeCommit($event)"
                                class="cn-form__control"
                                name="attribute value"
                            >
                                @for (opt of discreteOptions[attributeId]; track opt.itemId) {
                                    <option [value]="opt.itemId">
                                        {{ opt.itemName }}
                                    </option>
                                }
                            </select>
                        } @else {
                            <p class="text-value">{{ value }}</p>
                        }
                    }

                    @if (discreteOptions[attributeId] && multiVal === 1) {
                        @if (!readOnly) {
                            <s25-ng-generic-multiselect-dropdown
                                [items]="discreteOptions[attributeId]"
                                [onDone]="onDone"
                                [(chosen)]="multiVals"
                            >
                            </s25-ng-generic-multiselect-dropdown>
                        }
                        <p class="text-value">{{ textMultiVals() }}</p>
                    }
                </div>

                <div *ngSwitchCase="AttributeType.Integer">
                    <s25-ng-editable-number
                        (valChange)="onValueChange($event)"
                        [val]="toNumberOrUndefined(value)"
                        [hasCommit]="hasCommit"
                        [onCommit]="onCommit"
                        [readOnly]="readOnly"
                        [allowEmpty]="false"
                        name="attribute value"
                    ></s25-ng-editable-number>
                </div>

                <div *ngSwitchCase="AttributeType.Float">
                    <s25-ng-editable-number
                        (valChange)="onValueChange($event)"
                        [val]="toNumberOrUndefined(value)"
                        [hasCommit]="hasCommit"
                        [onCommit]="onCommit"
                        [readOnly]="readOnly"
                        [type]="'float'"
                        [min]="-9999999"
                        [allowEmpty]="false"
                        name="attribute value"
                    ></s25-ng-editable-number>
                </div>

                <div *ngSwitchCase="AttributeType.LongText">
                    <s25-ng-editable-textarea
                        (valChange)="onValueChange($event)"
                        [val]="value"
                        [rows]="10"
                        [cols]="50"
                        [hasCommit]="hasCommit"
                        [onCommit]="onCommit"
                        [fadePreview]="fadePreview"
                        [readOnly]="readOnly"
                        name="attribute value"
                    ></s25-ng-editable-textarea>
                </div>

                <div *ngSwitchCase="AttributeType.URL">
                    @if (!readOnly && hasUploadFile && !isUrlOnly()) {
                        <s25-toggle-button
                            (modelValueChange)="onToggleIsUploded($event)"
                            [modelValue]="isUploaded"
                            [trueLabel]="trueLabel"
                            [falseLabel]="falseLabel"
                            class="ngBlock c-margin-bottom--single"
                        ></s25-toggle-button>
                    }

                    @if (!isUploaded && !readOnly) {
                        <s25-ng-editable-text
                            (valChange)="onValueChange($event)"
                            [val]="value"
                            [hasCommit]="hasCommit"
                            [onCommit]="onCommit"
                            [readOnly]="readOnly"
                            name="attribute value"
                        ></s25-ng-editable-text>
                    } @else if (!isUploaded && readOnly) {
                        @let href = sanitizedUrl(value);
                        @if (href) {
                            <a [href]="href" target="_self">Click Here</a>
                        }
                    }

                    @if (!readOnly && isUploaded && hasUploadFile) {
                        <s25-ng-file-upload [multiple]="false" [showFiles]="false" [onAdd]="handleFileUpload">
                        </s25-ng-file-upload>
                    }

                    @if (uploaded) {
                        {{ file?.name }}
                    }

                    @if (isUploaded && !uploaded) {
                        <s25-ng-display-file [fileName]="fileName" [objectId]="objectId" [objectType]="objectType">
                        </s25-ng-display-file>
                        <div class=" c-margin-bottom--half"></div>
                    }
                    <!--   when migration event form, might need to ajust this, I think only event form use this logic -->
                    @if (editEventImage && (attributeId === -20 || attributeId === -21) && itemTypeId === 1) {
                        <s25-ng-editable-image
                            [showImage]="true"
                            [val]="value"
                            [onCommit]="imageAction"
                            (valChange)="onValueChange($event)"
                            [readOnly]="readOnly"
                            [autoSaveUpload]="true"
                        ></s25-ng-editable-image>
                    }
                </div>

                <div *ngSwitchCase="AttributeType.Date">
                    <s25-ng-editable-date
                        (valChange)="onValueChangeCommit($event)"
                        [val]="value"
                        [readOnly]="readOnly"
                        [allowEmpty]="false"
                        name="attribute value"
                    ></s25-ng-editable-date>
                </div>

                <div *ngSwitchCase="AttributeType.DateTime">
                    <s25-ng-editable-date-time
                        (valChange)="onValueChangeCommit($event)"
                        [val]="value"
                        [outputString]="true"
                        [readOnly]="readOnly"
                        name="attribute value"
                    ></s25-ng-editable-date-time>
                </div>

                <div *ngSwitchCase="AttributeType.Time">
                    <s25-timepicker
                        (modelValueChange)="onValueChangeCommit($event)"
                        [defaultNow]="true"
                        [modelValue]="value"
                        name="attribute value"
                    ></s25-timepicker>
                </div>

                <div *ngSwitchCase="AttributeType.Location">
                    <s25-ng-dropdown-search-criteria
                        [type]="'locations'"
                        [chosen]="value"
                        [blockDetailsNav]="blockDetailsNav"
                        (chosenChange)="onValueChangeCommit($any($event))"
                        name="attribute value"
                    ></s25-ng-dropdown-search-criteria>
                </div>

                <div *ngSwitchCase="AttributeType.Resource">
                    <s25-ng-dropdown-search-criteria
                        [type]="'resources'"
                        [chosen]="value"
                        [blockDetailsNav]="blockDetailsNav"
                        (chosenChange)="onValueChangeCommit($any($event))"
                        name="attribute value"
                    ></s25-ng-dropdown-search-criteria>
                </div>

                <div *ngSwitchCase="AttributeType.Organization">
                    <s25-ng-dropdown-search-criteria
                        [type]="'organizations'"
                        [chosen]="value"
                        [blockDetailsNav]="blockDetailsNav"
                        (chosenChange)="onValueChangeCommit($any($event))"
                        name="attribute value"
                    ></s25-ng-dropdown-search-criteria>
                </div>

                <div *ngSwitchCase="AttributeType.Contact">
                    <s25-ng-dropdown-search-criteria
                        [type]="'contacts'"
                        [chosen]="value"
                        [blockDetailsNav]="blockDetailsNav"
                        (chosenChange)="onValueChangeCommit($any($event))"
                        name="attribute value"
                    ></s25-ng-dropdown-search-criteria>
                </div>

                <div *ngSwitchCase="AttributeType.Image" class="imagePreview">
                    <s25-ng-editable-image
                        [showImage]="true"
                        [val]="value"
                        [onCommit]="imageAction"
                        (valChange)="onValueChangeCommit($event)"
                        [readOnly]="readOnly"
                        [autoSaveUpload]="true"
                    ></s25-ng-editable-image>
                </div>
            </div>
        </div>
    `,
    styles: `
        .imagePreview {
            max-width: 20em;
        }

        .text-value {
            overflow-wrap: break-word;
        }

        .attributeRow {
            overflow-wrap: break-word;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableCustomAttributeComponent extends S25EditableAbstract<any> implements OnInit {
    @Input() readOnly: boolean = true;
    @Input() attributeType: CustomAttributes.CustAttrCode;
    @Input() attributeId: number;
    @Input() attributeName: string;
    @Input() multiVal?: NumericalBoolean = 0;
    @Input() hasUploadFile?: boolean = false;
    @Input() type?: string = "";
    @Input() value?: CustomAttributes.ConditionValue;
    @Input() itemTypeId?: Item.Ids;
    @Input() objectId?: number;
    @Input() editEventImage?: boolean = false;
    @Input() blockDetailsNav?: boolean = false;
    @Output() valChange = new EventEmitter();
    @Output() markHasDiscreteOptions = new EventEmitter<boolean>();
    @ViewChild(FileUploadComponent) fileUploadComponent: FileUploadComponent;

    getType = () => this.type;

    init: boolean = false;
    AttributeType = CustomAttributes.type;
    discreteOptions: DropDownItem = {};
    uploaded: boolean = false;
    file: S25File;
    falseLabel: string = "Link";
    trueLabel: string = "Upload";
    isUploaded: boolean = false;
    fileName: string;
    objectType: number;
    isUrlUploadFile: boolean;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private zone: NgZone,
        private renderer: Renderer2,
    ) {
        super(elementRef, cd, zone, renderer);
    }

    async ngOnInit() {
        this.setCanEdit();
        this.isUrlUploadFile =
            this.attributeType === this.AttributeType.URL && FileStoreUtil.isFileStoreUrl(this.value);
        this.getFileName();
        this.init = true;
        this.cd.detectChanges();
        await this.setDiscreteOptions();
        super.ngOnInit();
    }

    getFileName() {
        if (this.isUrlUploadFile) {
            this.isUploaded = true;
            const params = FileStoreUtil.parseFileStoreUrl(this.value.toString());
            if (params) {
                this.objectType = params.objectType;
                this.fileName = params.fileName;
            }
        }
    }

    async onValueChangeCommit(e: any) {
        await this.onValueChange(e);
        this.onCommit?.(e);
    }

    async onValueChange(e: any) {
        this.valChange.emit(e);
        if (this.attributeType === this.AttributeType.URL && this.fileName) {
            await AttachmentService.delFile(this.itemTypeId, this.objectId, this.fileName);
            this.fileName = undefined;
            this.value = e;
        }
    }

    imageAction = (data: ModalImageI) => {
        this.valChange.emit(data);
        this.onCommit?.(data);
    };

    async setDiscreteOptions() {
        const toItem = (val: string) => ({ txt: val, val, itemName: val, itemId: val });
        const discreteOptions = await CustomAttributeService.getAllDiscreteOptions();
        for (let option of discreteOptions) {
            this.discreteOptions[option.itemId] = option.opt.map(toItem);

            // ANG-6524 If selected values are no longer options, add them to the list so that they still show
            const options = new Set(option.opt);
            if (!this.multiVal && this.value && !options.has(<string>this.value)) {
                this.discreteOptions[option.itemId].unshift(toItem(<string>this.value));
            }

            // ANG-6524 If selected values are no longer options, add them to the list so that they still show
            const items = <{ itemId: string; itemName: string }[]>this.value;
            if (this.multiVal && !!items?.length) {
                const missing = items.filter((item) => !options.has(item.itemId));
                this.discreteOptions[option.itemId] = missing.concat(this.discreteOptions[option.itemId]);
            }
        }

        this.discreteOptions[this.attributeId] && this.markHasDiscreteOptions.emit();
    }

    setCanEdit() {
        this.readOnly = this.readOnly || CustomAttributeService.isReadOnly(this.attributeId);
    }

    @Bind
    onDone({ items }: { items: DropDownItem[] }) {
        this.valChange.emit(items);
        this.onCommit?.(items);
    }

    handleFileUpload = async (file: S25File) => {
        const getFilesList = await AttachmentService.getFileList(this.itemTypeId, this.objectId).then(function (data) {
            //default to empty array ([]) to allow file upload
            return data || [];
        });
        const isNewFileExit = getFilesList.find((f) => f.itemName === file.name);
        if (isNewFileExit) {
            alert("You have already uploaded a file with this name.");
            return;
        } else {
            // if there is upload file exit for this CA. delete  old one then save the new one.
            if (this.fileName && this.fileName !== "") {
                await AttachmentService.delFile(this.itemTypeId, this.objectId, this.fileName);
            }
            this.file = file;
            this.fileName = file?.name as string;
            this.uploaded = true;
            this.valChange.emit(file);
            this.onCommit?.(file);
            this.cd.detectChanges();
        }
    };

    onToggleIsUploded($event: boolean) {
        this.isUploaded = $event;
        this.cd.detectChanges();
    }

    @Bind
    onRefresh(newVal: CustomAttributes.ConditionValue) {
        this.uploaded = false;
        this.value = newVal;
        this.getFileName();
        this.cd.detectChanges();
    }

    sanitizedUrl(value: string) {
        if (!value) return "";
        return value.startsWith("http://") || value.startsWith("https://") ? value : "http://" + value;
    }

    isUrlOnly(): boolean {
        let type: CustomAttributes.UrlAttributeType;
        switch (this.itemTypeId) {
            case Item.Ids.Event:
                type = "event_custom_attribute";
                break;
            case Item.Ids.Location:
                type = "location_custom_attribute";
                break;
            case Item.Ids.Resource:
                type = "resource_custom_attribute";
                break;
        }
        if (!type) return false;
        return MasterDefinitionUtil.isUrl(type, this.attributeType as string, this.attributeId);
    }

    toNumberOrUndefined(val: any): number | undefined {
        const num = Number(val);
        return isNaN(num) ? undefined : num;
    }

    textMultiVals() {
        return this.multiVals
            .map((val: DropDownItem) => val.itemName)
            .filter(S25Util.isDefined)
            .join("; ");
    }

    get multiVals() {
        return (this.value ?? []) as ItemValue[];
    }

    set multiVals(value: ItemValue[]) {
        this.value = value;
    }
}
